module.exports = __webpack_public_path__ + "img/p-single-4.26a788b4.jpg";